module.exports = __webpack_public_path__ + "img/acg-logo-white.ea7864b5.svg";